/**
 * ledgerSourceLineKey
 *
 * The 16-hex `fnv1a64` of one source line and its grain, the last segment of every accrual transaction id
 * and claim id. Hashes `JSON.stringify([formId, tableId, rowId, grainRef])`: the array quoting removes
 * separator ambiguity, and the text is re-derivable from a stored snapshot. The key is PERSISTED in
 * ids, so its spelling is frozen. Internal to `ledgerEngine`; consumers are `ledgerTransactionId` and
 * `ledgerClaimId`.
 */

import { fnv1a64 } from '../fnv1a64';
import type { LedgerSourceLine } from '../System.Ledger.Definition.types';

function ledgerSourceLineKey(sourceLine: LedgerSourceLine, grainRef: string | null): string {
    return fnv1a64(JSON.stringify([sourceLine.formId, sourceLine.tableId, sourceLine.rowId, grainRef]));
}

export { ledgerSourceLineKey };
